/**
 * Firebase implementation of `AuthProvider` (task_108).
 *
 * Thin adapter around the existing `authService` singleton. Deleted in
 * task_112 once Studio is the only path.
 */

import type { AuthProvider, AuthUser } from './AuthProvider';
import { authService } from './authService';

export class FirebaseAuthProvider implements AuthProvider {
  async signIn(email?: string, password?: string): Promise<AuthUser | void> {
    if (!email || !password) {
      throw new Error(
        'FirebaseAuthProvider.signIn requires email and password.'
      );
    }
    await authService.signIn(email, password);
    return authService.getCurrentUser() ?? undefined;
  }

  async signOut(): Promise<void> {
    await authService.signOut();
  }

  getCurrentUser(): AuthUser | null {
    return authService.getCurrentUser();
  }

  async getToken(): Promise<string | null> {
    return authService.getIdToken();
  }

  onAuthStateChanged(callback: (user: AuthUser | null) => void): () => void {
    return authService.onAuthStateChanged(callback);
  }
}
